import { Box, IconButton, InputAdornment, Stack, Tooltip } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import { useSnack } from 'shared/ui/snack';
import { useActionCreators, useStateSelector } from 'shared/store';
import { FormDialog } from 'shared/ui/form-dialog';
import { changePasswordActions } from './slice';
import { changeUserPasswordApi } from './api';
import { FormValues, initialValues, validate } from './form';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import { generatePassword } from 'utils/generate-auth-helper';

export const ChangePasswordDialog = () => {
  const open = useStateSelector(state => state.ui.changePasswordDialog.dialogOpen);
  const userId = useStateSelector(state => state.user.id);
  const [showPassword, setShowPassword] = useState(false);

  const { closeDialog, updatePasswordDate } = useActionCreators(changePasswordActions);
  const [submitChangePassword] = changeUserPasswordApi.useChangePasswordMutation();

  const { showSuccess, showError } = useSnack();

  const handleSubmit = async (formValues: FormValues) => {
    if (!userId) return Promise.reject();

    return submitChangePassword({
      userId,
      newPassword: formValues.password1
    })
      .unwrap()
      .then(() => {
        showSuccess('Пароль успешно изменен');
        updatePasswordDate(new Date().toISOString());
        closeDialog();
      })
      .catch((e) => showError('Ошибка изменения пароля', e));
  };

  const handleGeneratePassword = (setFieldValue: (field: string, value: string) => void) => {
    const newPassword = generatePassword();
    setFieldValue('password1', newPassword);
    setFieldValue('password2', newPassword);
  };

  return (
    <FormDialog
      open={open}
      onClose={() => closeDialog()}
      renderTitle="Смена пароля"
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      renderForm={(formikProps) => (
        <Box minWidth={300} my={1} py={1}>
          <Stack spacing={2}>
            {/*  TODO: ВЕРНУТЬ, КОГДА РЕШИМ СДЕЛАТЬ ВОССТАНОВЛЕНИЕ ПАРОЛЯ ЧЕРЕЗ EMAIL И ТД (feature/707) */}
            {/*<Field*/}
            {/*  fullWidth*/}
            {/*  required*/}
            {/*  name='currentPassword'*/}
            {/*  type="password"*/}
            {/*  label="Текущий пароль"*/}
            {/*  component={TextField}*/}
            {/*/>*/}
            {/*<Divider/>*/}
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Field
                  fullWidth
                  required
                  name='password1'
                  label="Новый пароль"
                  type={showPassword ? 'text' : 'password'}
                  component={TextField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
              <Tooltip title="Сгенерировать пароль">
                <IconButton 
                  color="primary" 
                  aria-label="generate-password" 
                  onClick={() => handleGeneratePassword(formikProps.setFieldValue)}
                  sx={{ mt: 1 }}
                >
                  <AutoFixHighIcon />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Field
                  fullWidth
                  required
                  name='password2'
                  label="Новый пароль еще раз"
                  type={showPassword ? 'text' : 'password'}
                  component={TextField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
              <Box sx={{ width: 40, mt: 1 }} />
            </Box>
          </Stack>
        </Box>
      )}
    />
  );
};